import { render, staticRenderFns } from "./evaluation-performance-scoring.vue?vue&type=template&id=2130f77e"
import script from "./evaluation-performance-scoring.vue?vue&type=script&lang=js"
export * from "./evaluation-performance-scoring.vue?vue&type=script&lang=js"
import style0 from "./evaluation-performance-scoring.vue?vue&type=style&index=0&id=2130f77e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports